import {
  Box,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import TableUpdate from "./tableUpdate";

export default function UpdateProjectMechanism() {

  const { saleOpeningEventId } = useParams();

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Box>
        <TableUpdate saleOpeningEventId={saleOpeningEventId} />
      </Box>
    </Box>
  );
}
